var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectricityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0203 22.0173C10.9003 22.0173 10.7903 21.9973 10.6803 21.9573C10.2703 21.8173 10.0103 21.4373 10.0103 21.0073V14.0073H5.01033C4.62033 14.0073 4.27033 13.7773 4.10033 13.4373C3.93033 13.0873 3.98033 12.6773 4.22033 12.3773L12.2203 2.37734C12.4803 2.03734 12.9303 1.91734 13.3323 2.05734C13.7323 2.19734 13.9923 2.56734 13.9923 2.99734V9.99734H18.9923C19.3723 9.99734 19.7223 10.2173 19.8923 10.5573C20.0523 10.8973 20.0123 11.3073 19.7623 11.6073L11.7623 21.6073C11.5623 21.8473 11.2723 21.9823 10.9823 21.9823L11.0203 22.0173ZM7.10033 12.0173H11.0103C11.5603 12.0173 12.0103 12.4573 12.0103 13.0173V18.1673L16.9203 12.0173H13.0003C12.4403 12.0173 12.0003 11.5673 12.0003 11.0173V5.86734L7.08033 12.0173H7.10033Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricityIcon);
export default __webpack_public_path__ + "static/media/electricity-icon.7dddd037045aae0a26baf95d85a5c3cc.svg";
export { ForwardRef as ReactComponent };